export function applyMiddleware (dispatch, getState, middlewares) {
  return middlewares.reduceRight(
    (next, middleware) => middleware(next, getState),
    dispatch
  )
}
